<template>
  <kt-panel>
    <div class="accordion accordion-toggle-arrow" id="userFilter">
      <div class="card" style="overflow:inherit">
        <div class="card-header bg-transparent" id="headingOne">
          <div class="card-title collapsed" data-toggle="collapse"
               data-target="#filterForm"
               aria-controls="filterForm">
            {{ $t('label.search') }}
          </div>
        </div>
        <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
          <div class="card-body">
            <form @submit.prevent="action($event, query)">
              <kt-form-section>
                <kt-form-row>
                  <kt-col xs="12" sm="6" md="4">
                    <kt-form-group>
                      <kt-form-label for="title">
                        {{ $t('label.category') }}
                      </kt-form-label>
                      <kt-form-control
                          ref="title"
                          dir="rtl"
                          name="title"
                          id="title"
                          v-model="query.title"
                      />
                    </kt-form-group>
                  </kt-col>
                </kt-form-row>
              </kt-form-section>

              <kt-form-section>
                <button id="category_filter_btn" type="submit" class="btn btn-success btn-wide">
                  {{ $t('label.filter') }}
                </button>
              </kt-form-section>
            </form>
          </div>
        </div>
      </div>
    </div>
  </kt-panel>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  props: {
    action: {
      default: function(e, query) {},
      required: true,
    }
  },
  data: function() {
    return {
      query: {},
    }
  },
}
</script>

<style scoped>

</style>